import { isDuringSchool, toEndOfSchoolDay } from '@chegg-wt/core/utils/dateTime'
import React from 'react'
import { connect } from 'react-redux'
import { EASYBIB, EB_DOMAIN, EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import Gateway from '@chegg-wt/core/components/Gateway'
import { AppRouteName } from '@chegg-wt/core/types/core'
import { flowed } from '@chegg-wt/core/state/app/actions'

interface GatewayPageProps {
  flowed: (routeName: AppRouteName) => void
}

const GatewayPage: React.FC<GatewayPageProps> = ({ flowed }) => {
  const now = new Date()
  const isValid = isDuringSchool(now)
  const expiration = toEndOfSchoolDay(now)
  const redirect = () => flowed('toCitationsHome')
  const afterSeconds = 5

  return (
    <Gateway
      isValid={isValid}
      expiration={expiration}
      domainName={EB_DOMAIN}
      siteName={EASYBIB}
      productName={EB_PRODUCT_NAME}
      redirect={redirect}
      afterSeconds={afterSeconds}
    />
  )
}

const mapDispatchToProps = {
  flowed,
}

export default connect(null, mapDispatchToProps)(GatewayPage)
